import { evaluateShowIf } from "@/utils/intakeHelpers";
import type { IntakeSectionDef } from "@/hooks/useIntakeForm";
import { IntakeField } from "./IntakeField";

type Props = {
  section: IntakeSectionDef;
  values: Record<string, unknown>;
  setFieldValue: (id: string, value: unknown) => void;
  errors: Record<string, string>;
  ageDays: number | null;
};

export function IntakeSection({
  section,
  values,
  setFieldValue,
  errors,
  ageDays,
}: Props) {
  if (!evaluateShowIf(section.show_if, values, ageDays)) return null;

  return (
    <section className="mb-8">
      <h3 className="mb-1 text-base font-semibold text-slate-900">{section.title}</h3>
      {section.note && (
        <p className="mb-3 text-xs text-slate-500">{section.note}</p>
      )}
      <div className="space-y-1">
        {section.fields.map((f) => (
          <IntakeField
            key={f.id}
            field={f}
            values={values}
            setFieldValue={setFieldValue}
            errors={errors}
          />
        ))}
      </div>
    </section>
  );
}
